const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '项目信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
            templateTypeOptions: [
                {
                    value: 3,
                    label: '采购文件模板',
                },
                {
                    value: 2,
                    label: '资格预审文件模板',
                },
            ],
            qualificationReviewModeOptions: [
                {
                    value: 2,
                    label: '资格预审',
                },
                {
                    value: 3,
                    label: '资格后审',
                },
            ],
        }
    },
    methods: {
        getData() {
            const guid = this.form.businessKey.split(':')[1]
            this.$request.post(`/transformToAfter/app/file/template/detail`, {
                templateGuid: guid,
            }, { showLoading: true }).then((res) => {
                this.config[1].options.data = {
                    '模板名称': res.data.templateName,
                    '项目类型': getProjectTypeName(res.data.projectTpye),
                    '采购方式': getPurchaseTypeName(res.data.purchaseMethod),
                    '模板类型': this.getTypeText(res.data.templateType),
                    '资格审查方式': this.getReviewMode(res.data.qualificationReviewMode),
            }
            })
        },
        getTypeText(key) {
            const exist = this.templateTypeOptions.find((t) => t.value === key)
            return exist ? exist.label : ''
        },
        getReviewMode(key) {
            const exist = this.qualificationReviewModeOptions.find((t) => t.value === key)
            return exist ? exist.label : ''
        },
        pass() {
            this.commit()
        },
        fail(opinion) {
            this.commit({
                opValue: '2', // 不通过
                opinion: opinion,
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
